import React from 'react';
import { Button } from '../../../ui';

const ServicePriceCard = ({ currency }) => {
  const plans = [
    'Keyword Research & Selection',
    'Technical Website Analysis & Opportunity Report',
    'AI-powered strategy recommendations',
    'On-page, off-page, and technical SEO practices are part of our offer guaranteed SEO services',
    'Engaging copy written by industry experts',
    'SEO & Analytics Tool Setup',
  ];

  const onScrollToPricingPlans = () => {
    const section = document.getElementById('pricing-plans');

    if (section) {
      section.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="flex lg:justify-between items-center lg:p-[10px] lg:flex-row flex-col lg:w-full lg:pb-0 max-w-[975px] rounded-b-[10px] overflow-hidden lg:shadow-none shadow-[0px_5px_10.4px_0px_rgba(0,0,0,0.24)] lg:bg-white bg-[#EEEAF9] pb-[20px]">
      <div className="w-full h-full lg:max-w-[398px] max-w-[548px] flex justify-center flex-col gap-[20px] ">
        <div className="flex flex-col justify-between lg:shadow-[0px_5px_10.4px_0px_rgba(0,0,0,0.24)] lg:rounded-tl-[10px] rounded-bl-[10px] overflow-hidden min-h-[390px] bg-[#F5F5F5]">
          <div className="flex flex-col flex-1 items-center justify-center text-center px-[32px] py-[24px] gap-[20px]">
            <p className="text-[24px] leading-[29px] font-[400]">Starting at competitive rates for our leading SEO tactics</p>
          </div>
          <div className="flex flex-col py-[24px] px-31 gap-[23px] bg-[#EEEAF9] ">
            <p className="text-[24px] leading-[29px] font-[600]">How we determine pricing</p>
            <ul className="list-none flex flex-col gap-[16px]">
              <li className="text-[18px] leading-[20px] font-[400] flex items-center gap-[10px]">
                <img src="/images/seo/icons/target.svg" className="h-[24px]" alt="icon" />
                <span>Your business goal discussion</span>
              </li>
              <li className="text-[18px] leading-[20px] font-[400] flex items-center gap-[10px]">
                <img src="/images/seo/icons/search.svg" className="h-[24px]" alt="icon" />
                <span>Your Market Analyze </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex justify-center items-center pb-[16px]">
          <a href={`/seo/seo-form`}>
            <Button variant="primary" narrowing="both" mode="light" className={'min-w-[180px]'}>
              Request Pricing
            </Button>
          </a>
        </div>
      </div>

      <div className="w-full h-full max-w-[548px] flex justify-center flex-col gap-[20px] mt-[15px] md:mt-0 ">
        <div className="flex flex-col rounded-r-[10px] px-[32px] py-[24px] gap-[8px] overflow-hidden bg-[#EEEAF9] lg:shadow-[0px_5px_10.4px_0px_rgba(0,0,0,0.24)] min-h-[390px]">
          <p className="text-[24px] font-[600] leading-[29px]">Included In all plans</p>
          <ul className="list-none flex flex-col gap-[16px]">
            {plans.map((plan, idx) => (
              <li key={idx} className="text-[18px] leading-[20px] font-[400] flex items-center gap-[10px]">
                <img src="/images/seo/icons/check-round.svg" className="h-[20px]" alt="icon" />
                <span className="leading-[30px]">{plan} </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex justify-center items-center pb-[16px]">
          <Button variant="black" narrowing="both" onClick={onScrollToPricingPlans} className={'min-w-[180px]'}>
            View all plans
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServicePriceCard;
